/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Win_S3Inputs */

const en_wc_dl_win_s3 = /** @type {(inputs: Wc_Dl_Win_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch WordCraft from the Start menu. Prefer no install? Unzip the portable .zip and run wordcraft.exe.`)
};

/**
* | output |
* | --- |
* | "Launch WordCraft from the Start menu. Prefer no install? Unzip the portable .zip and run wordcraft.exe." |
*
* @param {Wc_Dl_Win_S3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_win_s3 = /** @type {((inputs?: Wc_Dl_Win_S3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Win_S3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_win_s3(inputs)
});
export { wc_dl_win_s3 as "wc.dl.win.s3" }